import { render, staticRenderFns } from "./TwProcessGroupListEditIpRequestTable.vue?vue&type=template&id=783e882e&scoped=true&"
import script from "./TwProcessGroupListEditIpRequestTable.vue?vue&type=script&lang=js&"
export * from "./TwProcessGroupListEditIpRequestTable.vue?vue&type=script&lang=js&"
import style0 from "./TwProcessGroupListEditIpRequestTable.vue?vue&type=style&index=0&id=783e882e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "783e882e",
  null
  
)

export default component.exports